export default "__VITE_ASSET__DgfsDBHR__"